export const dropdownDonation = () => {
  if (document.querySelector('.wpcf_predefined_pledge_amount')) {
    const initialVal = $('.wpcf_predefined_pledge_amount option:selected').attr(
      'data-predefined-price'
    );

    $("input[name='wpneo_donate_amount_field']").val(initialVal);

    $('.wpcf_predefined_pledge_amount').on('change', () => {
      const value = $('option:selected', this).attr('data-predefined-price');
      $("input[name='wpneo_donate_amount_field']").val(value);
    });
  }
};
